<template>
    <v-container fluid class="root-step-container">
        <h2 class="text-h5 mb-4">{{ $t("risk-aversion.form1.title") }}</h2>
        <EqsSelect
            :value.sync="formData.p1q1"
            multiple
            v-bind="{
                label: $t('risk-aversion.form1.q1-label'),
                items: q1Items,
                ...schemaDouble.p1q1
            }"
        />
        <EqsSelect
            :value.sync="formData.p1q2"
            multiple
            v-bind="{
                label: $t('risk-aversion.form1.q2-label'),
                items: q2Items,
                ...schemaDouble.p1q2
            }"
        />
        <EqsRadio
            :value.sync="formData.p1q3"
            row
            v-bind="{
                label: $t('risk-aversion.form1.q3-label'),
                ...schemaDouble.p1q3
            }"
        />
        <div v-show="formData.p1q3 === 'yes'" class="pa-0 ma-0">
            <EqsSelect
                :value.sync="formData.p1q4"
                multiple
                v-bind="{
                    label: $t('risk-aversion.form1.q4-label'),
                    items: q4Items,
                    ...schemaDouble.p1q5
                }"
            />
        </div>
        <div v-show="formData.p1q3 === 'yes'" class="pa-0 ma-0">
            <EqsNumber
                :value.sync="formData.p1q5"
                :is-currency="false"
                :is-float="false"
                v-bind="{
                    label: $t('risk-aversion.form1.q5-label'),
                    editable: true,
                    placeholder: 'Ex: 20000',
                    ...schemaDouble.p1q5
                }"
            />
        </div>
        <div v-show="formData.p1q3 === 'yes'" class="pa-0 ma-0">
            <EqsSelect
                :value.sync="formData.p1q6"
                v-bind="{
                    label: $t('risk-aversion.form1.q6-label'),
                    items: q6Items,
                    ...schemaDouble.p1q6
                }"
            />
        </div>
        <div v-show="formData.p1q3 === 'yes'" class="pa-0 ma-0">
            <EqsSelect
                :value.sync="formData.p1q7"
                v-bind="{
                    label: $t('risk-aversion.form1.q7-label'),
                    items: q7Items,
                    ...schemaDouble.p1q7
                }"
            />
        </div>

        <EqsRadio
            :value.sync="formData.p1q8"
            row
            v-bind="{
                label: $t('risk-aversion.form1.q8-label'),
                ...schemaDouble.p1q8
            }"
        />
        <EqsRadio
            :value.sync="formData.p1q9"
            row
            v-bind="{
                label: $t('risk-aversion.form1.q9-label'),
                ...schemaDouble.p1q9
            }"
        />
        <div v-show="formData.p1q9 === 'yes'" class="pa-0 ma-0">
            <EqsText
                :value.sync="formData.p1q10"
                v-bind="{
                    label: $t('risk-aversion.form1.q10-label'),
                    editable,
                    placeholder: 'Ex: 8 moins',
                    ...schemaDouble.p1q10
                }"
            />
        </div>
        <EqsSelect
            :value.sync="formData.p1q11"
            v-bind="{
                label: $t('risk-aversion.form1.q11-label'),
                items: q11Items,
                ...schemaDouble.p1q11
            }"
        />
        <v-dialog
            v-model="dialogProxy"
            closable
            transition="dialog-bottom-transition"
            max-width="600"
        >
            <v-card class="pa-4">
                <v-card-title class="text-h5" style="word-break: break-word">
                    {{ $t("risk-aversion.form1.dialog-title") }}
                </v-card-title>
                <v-card-text>
                    <div v-html="$t('risk-aversion.form1.dialog-body')"></div>
                </v-card-text>
                <v-divider />
                <v-card-actions>
                    <v-spacer />
                    <v-btn color="primary" text @click="dialogProxy = false">
                        {{ $t("risk-aversion.form1.dialog-understood") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import { formMixin } from "@equisafe-ui-vue/src/mixins/formMixin";

export default {
    name: "Form1",
    mixins: [formMixin],
    props: {
        loading: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            dialogProxy: true
        };
    },
    computed: {
        q1Items() {
            return [
                { text: this.$t("risk-aversion.form1.q1-items.sme"), value: "PME" },
                { text: this.$t("risk-aversion.form1.q1-items.stock-market"), value: "Bourse" },
                { text: this.$t("risk-aversion.form1.q1-items.rental-property"), value: "Immobilier locatif" },
                { text: this.$t("risk-aversion.form1.q1-items.banking-products"), value: "Produits bancaire" },
                { text: this.$t("risk-aversion.form1.q1-items.pension-funds"), value: "Fonds de pension" },
                { text: this.$t("risk-aversion.form1.q1-items.investment-funds"), value: "Fonds d'investissement" }
            ];
        },
        q2Items() {
            return [
                { text: this.$t("risk-aversion.form1.q2-items.shares"), value: "Actions" },
                { text: this.$t("risk-aversion.form1.q2-items.bonds"), value: "Obligations" },
                { text: this.$t("risk-aversion.form1.q2-items.options"), value: "Options" },
                { text: this.$t("risk-aversion.form1.q2-items.commodities"), value: "Matières premières" },
                { text: this.$t("risk-aversion.form1.q2-items.currencies"), value: "Devises" },
                { text: this.$t("risk-aversion.form1.q2-items.derivatives"), value: "Produits dérivés" },
                { text: this.$t("risk-aversion.form1.q2-items.structured-products"), value: "Produits structurés" }
            ];
        },
        q4Items() {
            return [
                { text: this.$t("risk-aversion.form1.q4-items.shares"), value: "Actions" },
                { text: this.$t("risk-aversion.form1.q4-items.bonds"), value: "Obligations" },
                { text: this.$t("risk-aversion.form1.q4-items.options"), value: "Options" },
                { text: this.$t("risk-aversion.form1.q4-items.commodities"), value: "Matières premières" },
                { text: this.$t("risk-aversion.form1.q4-items.currencies"), value: "Devises" },
                { text: this.$t("risk-aversion.form1.q4-items.derivatives"), value: "Produits dérivés" },
                { text: this.$t("risk-aversion.form1.q4-items.structured-products"), value: "Produits structurés" },
                { text: this.$t("risk-aversion.form1.q4-items.other"), value: "Autres" }
            ];
        },
        q6Items() {
            return [
                { text: this.$t("risk-aversion.form1.q6-items.several-per-month"), value: "Plusieurs fois par mois" },
                { text: this.$t("risk-aversion.form1.q6-items.once-per-month"), value: "Une fois par mois" },
                { text: this.$t("risk-aversion.form1.q6-items.once-per-year"), value: "Une fois par an" }
            ];
        },
        q7Items() {
            return [
                { text: this.$t("risk-aversion.form1.q7-items.less-than-1-year"), value: "< 1 an" },
                { text: this.$t("risk-aversion.form1.q7-items.1-to-5-years"), value: "Entre 1 an et 5 ans" },
                { text: this.$t("risk-aversion.form1.q7-items.more-than-5-years"), value: "Plus de 5 ans" }
            ];
        },
        q11Items() {
            return [
                { text: this.$t("risk-aversion.form1.q11-items.none"), value: "Aucun" },
                { text: this.$t("risk-aversion.form1.q11-items.bts"), value: "BTS" },
                { text: this.$t("risk-aversion.form1.q11-items.bachelor"), value: "Licence" },
                { text: this.$t("risk-aversion.form1.q11-items.master"), value: "Master" },
                { text: this.$t("risk-aversion.form1.q11-items.doctorate"), value: "Doctorat" }
            ];
        }
    },
    watch: {
        "formData.p1q3": {
            handler(newVal, oldVal) {
                this.schemaDouble.p1q4.isRequired = newVal === "yes";
                this.schemaDouble.p1q5.isRequired = newVal === "yes";
                this.schemaDouble.p1q6.isRequired = newVal === "yes";
                this.schemaDouble.p1q7.isRequired = newVal === "yes";
            },
            immediate: true
        },
        "formData.p1q9": {
            handler(newVal, oldVal) {
                this.schemaDouble.p1q10.isRequired = newVal === "yes";
            },
            immediate: true
        }
    }
};
</script>

<style lang="scss" scoped></style>
